// Импорты "поведенческих" компонентов
import { Analytics } from '@/behaviour/analytics'
import { AnchorTop } from '@/behaviour/anchor_top/index'
import { AuthToastHelper } from '@/behaviour/auth_toast/index'
import { BrowserExtension } from '@/behaviour/browser_extension/index'
import { Collapser } from '@/behaviour/collapser/index'
import { HeaderNavigation } from '@/behaviour/header_navigation/index'
import { LeadsContactsMap } from '@/behaviour/leads_contacts_map/index'
import { LeadsPopularHelper } from '@/behaviour/leads_popular/index'
import { LeadsRemoteForm } from '@/behaviour/leads_remote_form/index'
import { LeadsUserCallback } from '@/behaviour/leads_user_callback/index'
import { LinkBlockHelper } from '@/behaviour/link_block_helper/index'
import { MaskedInput } from '@/behaviour/masked_input/index'
import { ModalsFooters } from '@/behaviour/modals-footers/index'
import { PasswordTypeSwitcher } from '@/behaviour/password_type_switcher/index'
import { RackAttackHelper } from '@/behaviour/rate_limit/index'
import { RequestSettings } from '@/behaviour/request/index'
import { Select2 } from '@/behaviour/select2/index'
import { Sidebar } from '@/behaviour/sidebar/index'
import { SlickCarousel } from '@/behaviour/slick_slider/index'
import { SubscribersForm } from '@/behaviour/subscribers/new/index'
import { Tabs } from '@/behaviour/tabs/index'
import { Tooltipster } from '@/behaviour/tooltipster/index'
import { CsrfToken } from '@/behaviour/update_csrf_token/index'
import { isGispOrigin } from '@/libs/env/index'

import { UserCallbacks } from '@/behaviour/users/callbacks/index'
import { UsersSessions } from '@/behaviour/users/sessions/index'
import { UsersSessionsNewPage } from '@/behaviour/users/sessions/new/index'

// Инициализация "поведенческих" компонентов
const initBehaviors = () => {
  [
    Analytics,
    AnchorTop,
    AuthToastHelper,
    BrowserExtension,
    Collapser,
    HeaderNavigation,
    LeadsContactsMap,
    LeadsPopularHelper,
    LeadsRemoteForm,
    LeadsUserCallback,
    LinkBlockHelper,
    MaskedInput,
    ModalsFooters,
    PasswordTypeSwitcher,
    RackAttackHelper,
    RequestSettings,
    Select2,
    Sidebar,
    SlickCarousel,
    SubscribersForm,
    Tabs,
    Tooltipster,
    CsrfToken,
    UserCallbacks,
    UsersSessions,
    UsersSessionsNewPage,
  ].forEach((behavior) => new behavior())

  if (isGispOrigin) {
    const gisp = import('@/behaviour/gisp/index').then((module) => {
      const moduleGisp = new module.Gisp()
    })
  }
}

initBehaviors()
